export const bulkScenarioUpload = () => {
    return {
        SET_BULK_INPUT_UPLOAD_FILE: "SET_BULK_INPUT_UPLOAD_FILE",
        SET_BULK_INPUT_UPLOAD_PROGRESS: "SET_BULK_INPUT_UPLOAD_PROGRESS",
        SUCCESS_UPLOAD_BULK_INPUT_FILE: "SUCCESS_UPLOAD_BULK_INPUT_FILE",
        FAILURE_UPLOAD_BULK_INPUT_FILE: "FAILURE_UPLOAD_BULK_INPUT_FILE",
        RESET_UPLOAD_BULK_INPUT_FILE: "RESET_UPLOAD_BULK_INPUT_FILE",
    };
};

export const SET_UPLOAD_SUCCESS_STATUS = "SET_UPLOAD_SUCCESS_STATUS";

export const SET_EXTRACTION_REQUEST = "SET_EXTRACTION_REQUEST";
export const SET_EXTRACTION_SUCCESS = "SET_EXTRACTION_SUCCESS";
export const SET_EXTRACTION_ERROR = "SET_EXTRACTION_ERROR";

// export const SET_BULK_UPLOAD_REQUEST = "SET_BULK_UPLOAD_REQUEST";
// export const SET_BULK_UPLOAD_SUCCESS = "SET_BULK_UPLOAD_SUCCESS";
// export const SET_BULK_UPLOAD_ERROR = "SET_BULK_UPLOAD_ERROR";
